import React from 'react';
import moment from 'moment/moment';
import SearchRideTimes from '../../../../../pages/search/components/searchRide/components/SearchRideTimes';
import { ReactComponent as Train } from '../../../../../../../resources/images/svg/train.svg';
import useTranslation from '../../../../../../hooks/translation/useTranslation';
import { useAuth } from '../../../../../../contexts/userContext/userContext';

function ChosenRideDetails({ chosenRide }) {
  const { currentLanguage } = useTranslation();

  const { ticketBookingOptions } = useAuth();

  const rideDetails = {
    rideNumber: chosenRide?.rideNumber,

    actualStartStation: chosenRide?.rideActualStation?.station?.code
    || chosenRide?.rideActualStation?.code || chosenRide?.rideStartStation?.code
    || chosenRide?.rideStartStation?.station?.code,

    actualEndStation: chosenRide?.rideEndStation?.station?.code
    || chosenRide?.rideEndStation?.code,

    departure: {
      date: moment(chosenRide?.startStation?.departureDateTime || chosenRide?.startDateTime),
      stationCode: chosenRide?.startStation?.station?.code || chosenRide?.startStation?.code,
    },

    arrival: {
      date: moment(chosenRide?.endStation?.arrivalDateTime || chosenRide?.endDateTime),
      stationCode: chosenRide?.endStation?.station?.code || chosenRide?.endStation?.code,
    },
  };

  const rideEndStation = ticketBookingOptions?.stations?.find(
    (station) => `${station?.value}` === `${rideDetails.actualEndStation}`,
  );

  const rideStartStation = ticketBookingOptions?.stations?.find(
    (station) => `${station?.value}` === `${rideDetails.actualStartStation}`,
  );

  return (
    <div className={`expander ${chosenRide && 'expanded'}`}>
      <div className="expander-content">
        <div className={`flex flex-col gap-2 text-base ease-out duration-300 opacity-0 ${chosenRide && 'opacity-100'} `}>
          <div className="flex gap-2 items-center">
            <Train />
            <div className="flex gap-2">
              <p className="m-0">
                N
                {chosenRide?.rideNumber}
              </p>
              <p className="m-0">
                {
                  rideStartStation?.[`label_${currentLanguage === 'am' ? 'ka' : currentLanguage}`]
                  || rideStartStation?.label_ka
                }
                {' '}
                -
                {' '}
                {
                  rideEndStation?.[`label_${currentLanguage === 'am' ? 'ka' : currentLanguage}`]
                  || rideEndStation?.label_ka
                }
              </p>
            </div>
          </div>
          <SearchRideTimes ride={rideDetails} vertical />
        </div>
      </div>
    </div>
  );
}

export default ChosenRideDetails;
